




































































import Message from '@/types/Message.interface'
import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
import jsPDF from 'jspdf'
import moment from 'moment-timezone'
export default Vue.extend({
    props: {
        person: {
            type: Object as PropType<Person>,
            required: true
        },
        start_date: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            el: 1,
            loading: false,
            menu1: null,
            menu2: null,
            reversed: null,
            messages: [],
            filtered: null,
            startDate: new Date().toISOString().substr(0, 10),
            endDate: new Date().toISOString().substr(0, 10)
        }
    },
    mounted() {
        //  If we have a start date prop set, change our actual start to it
        if (this.start_date) {
            //  Convert our start date into a Date
            const d = window.getDate(this.start_date)

            //  Apply date using moment
            this.startDate = moment(d).format().substr(0, 10)
        }
    },
    computed: {
        startDateFormatted(): string {
            return this.formatDate(this.startDate)
        },
        endDateFormatted(): string {
            return this.formatDate(this.endDate)
        }
    },
    methods: {
        async getMessages(): Promise<void> {
            //  Create our params to find these messages
            const params = {
                channel_id: this.person.primary_channel_id,
                start_date: this.startDate,
                end_date: this.endDate
            }

            //  Start loading
            this.loading = true

            //  Get our PDF messages
            const messages = await this.$store.dispatch('messagesGetPdf', params)

            //  Our request finished so stop loading
            this.loading = false

            //  In case we did this before, remove dupes
            this.messages = window.removeDuplicatesById(this.messages, messages)

            //  Reverse the messages so they appear the same as the SmsMessagesPanel
            this.reversed = this.messages.reverse()

            //  If we have messages after doing all of this, print the PDF
            if (this.reversed && this.reversed.length > 0) {
                this.createPDF(this.reversed)
            }
            //  Else, something happened so pop a dialog telling the user
            else {
                this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'No Messages Found',
                    text: 'There are no messages that exist in the selected date range.',
                    icon: 'mdi-alert-circle'
                })
            }
        },
        async createPDF(filtered: Message[]): Promise<void> {
            //  Containers for our text going into the PDF and our current yPosition for writing
            let docText = ''
            let yPos = 10

            //  Create a new jdPDF object
            const doc = new jsPDF()

            //  Set our font size in the doc to 12pt
            doc.setFontSize(12)

            //Storing filtered messages in docText variable
            for (let j = 0; j < filtered.length; j++) {
                //  Get our message
                let message = filtered[j]

                //  Our sent date SHOULD be delivered, but we default to updated_at if unavailable
                let sentDate = message.created_at || message.updated_at

                //  Construct our date from the timestamp on the message
                let date = this.$options.filters.chatDate(sentDate)

                //  Grab our author from the message
                let author = await this.$store.dispatch('getMessageAuthor', message)

                //  If there is an author, grab the first name ELSE just set to "MessageDesk" because it is an automated msg
                let name = author ? author.name_given : 'MessageDesk'

                //  Get our message text
                let msgText = this.$options.filters.parseCommentedText(
                    message.text,
                    false
                )

                //  Create the line we want to append to our document
                let txt = `${name}: ${msgText} (${date})\n------------------------------------------------------------------------------------------------------------------------\n`

                //  Append our new line we made to our document
                docText += txt
            }

            //  Splitting text to allow multi-line messages to fit in PDF (this returns an array of strings)
            const splitDocText = doc.splitTextToSize(docText, 180)

            //looping through array of splitDocText and adding text to PDF document, creating new page if necessary
            for (let k = 0; k < splitDocText.length; k++) {
                //  Grab our current page height
                let pageHeight = doc.internal.pageSize.height

                //  If our yPos ends up being too large, we need to add a page and reset it to 10
                if (yPos >= pageHeight - 10) {
                    doc.addPage()
                    yPos = 10
                }

                //  Add our text to the document
                doc.text(splitDocText[k], 10, yPos)

                //  Increment our y position
                yPos += 5
            }

            //  Grab our last name and first name
            const names = `${this.person.name_family}_${this.person.name_given}`

            //  Grab our dates
            const dates = `${this.startDate.substr(0, 10)}-${this.endDate.substr(0, 10)}`

            //  Our title container
            const title = `Conversation_${names}_${dates}.pdf`

            //  Start PDF download in browser
            doc.save(title)

            //  Make sure our messages array gets reset to empty
            this.messages = []
        },
        formatDate(date: string): string {
            //  If there is no date, return null
            if (!date) return null

            //  Else, we want our year, month, and day from the date
            const [year, month, day] = date.split('-')

            //  Combine these into a formatted date string
            return `${month}/${day}/${year}`
        }
    }
})
